<template>
  <div id="app">
    <app-header/>
    <router-view></router-view>
    <app-footer/>
    <!-- <transition
      name="loader-animation"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
    </transition>

    <app-header/>
    <transition name="page-transition" mode="out-in" appear>
      <router-view></router-view>
    </transition>
    <app-footer/> -->
  </div>
</template>

<script>
// import { mapGetters, mapActions, mapMutations } from "vuex";
import Header from "./components/partials/Header.vue";
import Footer from "./components/partials/Footer.vue";
// import ProgressBar from "./components/partials/ProgressBar.vue";

export default {
  data() {
    return {
      // isLoading: false,
      // isFullPage: true,
      // showLoader: true
    };
  },
  // computed: {
  //   ...mapGetters({
  //     isLoading: "isLoading",
  //     loadingProgress: "loadingProgress"
  //   }),

  //   loaderStyle() {
  //     return `width: ${this.loadingProgress}%;`;
  //   }
  // },
  // created() {
  //   this.isLoading = true;
  // },
  components: {
    appHeader: Header,
    appFooter: Footer,
    // ProgressBar
  },

  // watch: {
  //   // watch the value of isLoading and once it's false hide the loader
  //   isLoading(val) {
  //     if (val == false) {
  //       let self = this;
  //       setTimeout(function() {
  //         self.showLoader = false;
  //       }, 1000);
  //     }
  //   }
  // }
};
</script>